export default __webpack_public_path__ + "static/media/email-invite.c23b8e38.svg";